/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Spaces_Drop_Files_SubtitleInputs */



/**
* | output |
* | --- |
* | "Files will be uploaded to {target}" |
*
* @param {Spaces_Drop_Files_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_drop_files_subtitle = /** @type {((inputs: Spaces_Drop_Files_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Drop_Files_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dateien werden zu ${i?.target} hochgeladen`)
	return /** @type {LocalizedString} */ (`Files will be uploaded to ${i?.target}`)
});